import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { ChartEvent, ChartOptions } from 'chart.js';
import { BaseChartDirective } from "ng2-charts";

export class LineData {
    lineMap:any = {}
    labels:string[] = []

    constructor() {
    }

    addLine(name:string, values:number[]) {
        this.lineMap[name] = values
    }

    addLabel(label:string) {
        this.labels.push(label)
    }
}

@Component({
    selector: 'app-line-chart',
    standalone: false,
    templateUrl: './line-chart.html',
    styleUrls: ['./line-chart.css']
})
export class LineChartComponent implements OnInit, OnChanges {
    @Input() data: LineData
    @Input() width: number
    @Input() height:number
    @Input() selectable = false                    // whether clicking the chart chooses a point (such as a day)
    @Output() pointSelected = new EventEmitter<number>()   // the index of the label chosen
    @ViewChild(BaseChartDirective) chartDirective?:BaseChartDirective
   
    public chartOptions: ChartOptions<'line'> = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                display: true
            }
          }
    };

    public chartLegend = true;
    public chartPlugins = [];

    labels = []
    values = []
    
    constructor(@Inject(LOCALE_ID) public locale: string) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        // a click anywhere over a label chooses it, rather than only on a line's point
        if (changes["selectable"]) this.chartOptions = this.selectable
            ? { ...this.chartOptions, interaction: { mode: 'index', intersect: false }, onHover: (event, active) => {
                const target = event.native?.target as HTMLElement | undefined
                if (target) target.style.cursor = active.length ? 'pointer' : 'default'
            } }
            : this.chartOptions
        if (changes["data"]) { 
            this.populateData()
        }
    }

    ngOnInit(): void {
        this.populateData()
    }

    populateData() {
        if (!this.data) return
        this.labels = this.data.labels
        this.values = Object.keys(this.data.lineMap).map(l => {
            return {label:l, data: this.data.lineMap[l]}
        })
    }

    hideChart() {}

    // the label under the click, looked up from where it was rather than what the pointer last hovered over
    onSelect(event:{event?:ChartEvent, active?:object[]}): void {
        if (!this.selectable) return
        const chart = this.chartDirective?.chart
        const native = event?.event?.native
        const found = chart && native ? chart.getElementsAtEventForMode(native, 'index', { intersect: false }, true) : []
        const index = found[0]?.index ?? (event?.active?.[0] as {index?:number}|undefined)?.index
        if (index !== undefined) this.pointSelected.emit(index)
    }
}
